import { css } from '@emotion/css'
import React, { CSSProperties, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import IPButton from '../IPButton'
import './IPModal.scss'
import { Link } from 'react-router-dom'

interface IPModalProps {
  show: boolean
  onClose?: () => void
  onConfirm?: () => void
  onExcel?: () => void
  confirmText?: string
  hideConfirm?: boolean
  children: JSX.Element
  buttons?: JSX.Element
  checkbox?: JSX.Element
  title?: React.ReactNode
  closeOnEscapeKey?: boolean
  style?: CSSProperties
  width?: Number | 'auto'
  height?: Number | 'auto'
  maxWidth?: Number
  link?: string
  bodyOverflow?: boolean
  excelButton?: boolean
  className?: string
  // Verilirse başlığın sağında tam ekran / küçült ikonu çıkar; durum çağıran tarafta tutulur.
  maximized?: boolean
  onToggleMaximize?: () => void
}

const IPModal = (props: IPModalProps) => {
  const closeOnEscapeKeyDown = (e: KeyboardEvent) => {
    if (props.closeOnEscapeKey) {
      const key = e.key || e.keyCode

      if (key === 'Escape' || key === 'Esc' || key === 27) {
        props.onClose && props.onClose()
      }
    }
  }

  useEffect(() => {
    props.closeOnEscapeKey && document.body.addEventListener('keydown', closeOnEscapeKeyDown)

    return function cleanup() {
      props.closeOnEscapeKey && document.body.removeEventListener('keydown', closeOnEscapeKeyDown)
    }
  }, [])

  return ReactDOM.createPortal(
    // appear: show=true ile mount edilen modal da 'enter-done' sınıfını alır; yoksa opacity 0 / pointer-events none kalır.
    <CSSTransition in={props.show} appear unmountOnExit timeout={{ appear: 0, enter: 0, exit: 300 }}>
      {/* className sabit kalmalı: CSSTransition 'enter-done'u DOM'a ekliyor, React className'i yeniden yazarsa silinir ve modal görünmez olur. */}
      <div className='modal' style={props.maximized ? { ...props.style, padding: 0 } : props.style}>
        <div
          className={`modal-content ${props.maximized ? 'modal-content--maximized' : ''} ${props.className ?? ''} ${css`
            ${props.width && 'width:' + props.width}${typeof props.width === 'number' && 'px'};
            ${props.height && 'height:' + props.height}${typeof props.height === 'number' && 'px'};
            ${props.maxWidth && 'max-width:' + props.maxWidth}px;
          `}`}
          onClick={e => e.stopPropagation()}
        >
          {(props.title || props.onToggleMaximize) && (
            <div className={`modal-header ${props.onToggleMaximize ? 'modal-header--with-actions' : ''}`}>
              <h4 className='modal-title'>{props.title}</h4>
              {props.onToggleMaximize && (
                <button
                  type='button'
                  className='modal-maximize-button'
                  title={props.maximized ? 'Küçült' : 'Tam Ekran'}
                  aria-label={props.maximized ? 'Küçült' : 'Tam Ekran'}
                  onClick={props.onToggleMaximize}
                >
                  <i className={props.maximized ? 'fas fa-compress' : 'fas fa-expand'} />
                </button>
              )}
            </div>
          )}
          <div
            className='modal-body'
            style={{
              overflowY: props.bodyOverflow ? 'auto' : 'unset', // Proper conditional styling
            }}
          >
            {props.children}
          </div>
          <div className='modal-footer'>
            {props.checkbox ? (
              <div
                style={{
                  display: 'flex',
                  flex: 'auto',
                }}
              >
                {props.checkbox}
              </div>
            ) : (
              ''
            )}
            {props.link && props.link.length > 0
              ? props.hideConfirm
                ? props.hideConfirm
                : true && (
                  <Link to={props.link}>
                    <IPButton
                      text={props.confirmText ? props.confirmText : 'Kaydet'}
                      style={{ width: 'auto', padding: '15px 20px', backgroundColor: 'blue' }}
                      className='modal-button'
                    // onClick={props.onConfirm}
                    />
                  </Link>
                )
              : props.hideConfirm
                ? props.hideConfirm
                : true && (
                  <IPButton
                    text={props.confirmText ? props.confirmText : 'Kaydet'}
                    style={{ width: 'auto', padding: '15px 20px', backgroundColor: 'blue' }}
                    className='modal-button'
                    onClick={props.onConfirm}
                  />
                )}
            {props.excelButton ? <IPButton
              id='closeButton'
              text='Excel İndir'
              style={{ width: 'auto', padding: '15px 20px', backgroundColor: 'green' }}
              className='modal-button'
              onClick={props.onExcel}
            /> : ''}

            {props.buttons ? props.buttons : ''}
            <IPButton
              id='closeButton'
              text='Kapat'
              style={{ width: 'auto', padding: '15px 20px' }}
              className='modal-button'
              onClick={props.onClose}
            />
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById('ip-modal')!
  )
}

export default IPModal
